export default "__VITE_ASSET__b7611d20__"